import clsx from "clsx";

import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "common/components/ui/Accordion";

import type { JSX, ReactNode } from "react";

interface SelectionFilterProps {
  label: string;
  tagsComponent: JSX.Element;
  children: ReactNode;
}

export default function SelectionFilter({
  label,
  tagsComponent,
  children,
}: SelectionFilterProps) {
  return (
    <AccordionItem
      value={label}
      key={label}
      className="group transition-colors data-[state=open]:bg-white"
    >
      <AccordionTrigger className="flex items-center justify-between gap-x-1.5 px-2 lg:px-1.5 py-2.5 lg:py-1.75 text-left text-button-sm lg:text-button-xs lg:mx-2">
        {label}
      </AccordionTrigger>

      {tagsComponent}

      <AccordionContent className="flex flex-col gap-y-1.5 px-2 pb-2 pt-2 lg:pt-1.5">
        {children}
      </AccordionContent>

      <div
        className={clsx(
          "lg:mx-2 h-px bg-black-200 group-last:hidden",
          tagsComponent && "group-data-[state=closed]:mt-2",
        )}
      />
    </AccordionItem>
  );
}
